"use client";

import { ReactNode, useEffect } from "react";
import ErrorBoundary from "./ErrorBoundary";

interface ErrorTrackingProviderProps {
  children: ReactNode;
}

export const ErrorTrackingProvider = ({
  children,
}: ErrorTrackingProviderProps) => {
  useEffect(() => {}, []);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};
